import React from "react";

function EmailIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            fill="none"
            viewBox="0 0 34 34"
        >
            <mask
                id="mask0_0_5193"
                style={{ maskType: "alpha" }}
                width="34"
                height="34"
                x="0"
                y="0"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#D9D9D9"
                    d="M0.906 0.806H33.164V33.064H0.906z"
                ></path>
            </mask>
            <g mask="url(#mask0_0_5193)">
                <path
                    fill="#000"
                    d="M27.541 10.795a2.172 2.172 0 00-2.168-2.127H7.926c-1.182 0-2.145.95-2.168 2.127v12.288a2.172 2.172 0 002.171 2.153h17.444c1.19 0 2.161-.963 2.172-2.153V10.797l-.004-.002zm-2.168 13.53H7.926a1.26 1.26 0 01-1.237-1.039l7.51-5.338.39.315c.597.488 1.328.731 2.058.731.73 0 1.464-.243 2.06-.73l.388-.316 7.51 5.338a1.258 1.258 0 01-1.237 1.039h.005zM7.926 9.58h17.447c.626 0 1.14.46 1.237 1.057l-8.479 6.92a2.35 2.35 0 01-2.964 0l-8.478-6.92a1.257 1.257 0 011.237-1.057zm11.905 7.769l6.8-5.548v10.38l-6.8-4.832zM6.669 11.802l6.8 5.548-6.8 4.832v-10.38z"
                ></path>
            </g>
        </svg>
    );
}

export default EmailIcon;
